<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="title-header">{{ 'form-builder.title' | translate | titlecase }}</span>
</div>
<form #formBuilderForm="ngForm">
  <div class="mct-flex mct-col mct-gap-27"  >
    <div *ngIf="!formType">
      <label>{{ 'form-builder.form-type-label' | translate | titlecase }}</label>
      <p-select name="formType" [options]="formTypeOptions" [style]="{ width: '100%' }" [(ngModel)]="formType" appendTo="body"></p-select>
    </div>
    <div *ngIf="formType">
      <wl-card [ngSwitch]="formType">
        <span *ngSwitchCase="formTypeEnum.Join">why are you here?</span>
        <wl-donation-form-edit *ngSwitchCase="formTypeEnum.Donation" (formSaved)="formSaved($event)"></wl-donation-form-edit>
        <wl-renewal-form-edit *ngSwitchCase="formTypeEnum.Renewal" (formSaved)="formSaved($event)"></wl-renewal-form-edit>
        <wl-general-form-edit *ngSwitchCase="formTypeEnum.GeneralSurvey" (formSaved)="formSaved($event)"></wl-general-form-edit>
        <wl-prospect-form-edit *ngSwitchCase="formTypeEnum.Prospect" (formSaved)="formSaved($event)"></wl-prospect-form-edit>
      </wl-card>
    </div>
  </div>
</form>
